import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'parseFloat',
    standalone: false
})
export class ParseFloatPipe implements PipeTransform {

  public transform(val: string): number {
    return parseFloat(val);
  }
}
